import { EUserRole } from "@/types/enum";

export const formInputs = [
  {
    inputType: "email",
    prompt: "Email address",
    name: "email",
    placeholder: "Enter email",
    fullWidth: true,
    rules: {
      isEmail: {
        expectedValue: true,
        errorMessage: "Not a valid email address",
      },
    },
  },

  {
    fullWidth: true,
    inputType: "password",
    prompt: "Password",
    name: "password",
    placeholder: "Enter password",
  },
];

export const resetPasswordInputs = [
  {
    inputType: "email",
    prompt: "Email address",
    name: "email",
    placeholder: "Enter email",
    fullWidth: true,
    rules: {
      isEmail: {
        expectedValue: true,
        errorMessage: "Not a valid email address",
      },
    },
  },
];

export const stageToNumber: any = {
  email_verification_stage: 1,
  phone_number_verification_stage: 2,
  tin_verification_stage: 3,
  pcn_licence_stage: 4,
};

export const invitedUsers = [
  EUserRole.HEAD_OF_PHARMACY,
  EUserRole.HOSPITAL_ACCOUNTANT,
  EUserRole.MINISTRY_OF_HEALTH_DG,
  EUserRole.MINISTRY_OF_HEALTH_SECRETARY,
] as const;

export type InvitedUserRole = (typeof invitedUsers)[number];

export const invitedUserDashboard: Record<InvitedUserRole, string> = {
  [EUserRole.HEAD_OF_PHARMACY]: "/dashboard/pharmacy-head/stat",
  [EUserRole.HOSPITAL_ACCOUNTANT]: "/dashboard/accountant/financials",
  [EUserRole.MINISTRY_OF_HEALTH_DG]: "/dashboard/dg-health/financials",
  [EUserRole.MINISTRY_OF_HEALTH_SECRETARY]:
    "/dashboard/state-sec/dashboard/drf",
};
